import { useRef } from 'react';

import { BtnGroup, BtnToolbar, Button } from '@dec/shared';
import { PageToPrint } from 'app/modules/Reports/Preview/pageToPrint';
import { useGetTaxReturnById } from 'app/modules/Reports/TaxReturnList/hooks';
import * as icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

import './style.scss';
export const TaxReturnPreview = () => {
  const { t, i18n } = useTranslation();
  const componentRef = useRef<any>(null);
  const { taxReturnId } = useParams<Record<string, string>>();
  const { loading, taxreturn } = useGetTaxReturnById(taxReturnId ?? '');

  const pageStyle = `

  @page {
    size: 80mm 50mm;
  }


`;

  const handlePrint = useReactToPrint({
    pageStyle,
    bodyClass: 'body_print',
    contentRef: componentRef
  } as any);
  if (loading) {
    return <></>;
  }

  return (
    <>
      <BtnToolbar>
        <BtnGroup>
          <></>
        </BtnGroup>
        <BtnGroup>
          <Button
            icon={icon.Printer}
            text={t('common.label.print')}
            variant="primary"
            onClick={handlePrint}
          />
        </BtnGroup>
      </BtnToolbar>
      <PageToPrint ref={componentRef} taxreturn={taxreturn!} />
    </>
  );
};
